import React from 'react';
import { Link } from '../Link.jsx';
import AuthorizedAction from '../AuthorizedAction.js';
import { getOrgSlug } from '../../lib/utils.js';
import { replaceRoute } from '../../lib/router.js';
import { isEmpty, pickBy } from 'lodash';

export const ChangeImpactsLink = ({ projectId, ...props }) => (
  <AuthorizedAction action="read" subject="changeImpact">
    <Link
      route="projects/change-impacts"
      params={{ projectId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const ChangeImpactLink = ({ projectId, changeImpactId, ...props }) => (
  <Link
    route="projects/change-impacts/show"
    params={{
      projectId,
      changeImpactId,
      slug: getOrgSlug(),
    }}
    {...props}
  />
);

export const NewChangeImpactLink = ({ projectId, ...props }) => (
  <AuthorizedAction action="create" subject="changeImpact">
    <Link
      route="projects/change-impacts/new"
      params={{ projectId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const EditChangeImpactLink = ({
  projectId,
  changeImpactId,
  ...props
}) => (
  <AuthorizedAction action="update" subject="changeImpact">
    <Link
      route="projects/change-impacts/edit"
      params={{
        projectId,
        changeImpactId,
        slug: getOrgSlug(),
      }}
      {...props}
    />
  </AuthorizedAction>
);

export const TaskLink = ({ projectId, changeImpactId, taskId, ...props }) => (
  <AuthorizedAction action="read" subject="task">
    <Link
      route="projects/change-impacts/tasks/show"
      params={{
        projectId,
        changeImpactId,
        taskId,
        slug: getOrgSlug(),
      }}
      {...props}
    />
  </AuthorizedAction>
);

export const NewTaskLink = ({ projectId, changeImpactId, ...props }) => (
  <AuthorizedAction action="update" subject="task">
    <Link
      route="projects/change-impacts/tasks/new"
      params={{
        projectId,
        changeImpactId,
        slug: getOrgSlug(),
      }}
      {...props}
    />
  </AuthorizedAction>
);

export const EditTaskLink = ({
  projectId,
  changeImpactId,
  taskId,
  ...props
}) => (
  <AuthorizedAction action="update" subject="task">
    <Link
      route="projects/change-impacts/tasks/edit"
      params={{
        projectId,
        changeImpactId,
        taskId,
        slug: getOrgSlug(),
      }}
      {...props}
    />
  </AuthorizedAction>
);

export const navigateToChangeImpact = (query, projectId) => {
  // Extract projectId from URL if not provided
  if (!projectId) {
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const projectsIndex = pathParts.indexOf('projects');
    if (projectsIndex !== -1 && pathParts[projectsIndex + 1]) {
      projectId = parseInt(pathParts[projectsIndex + 1], 10);
    }
  }

  const existingParams = window.location.pathname.includes(
    '/projects/change-impacts'
  )
    ? Object.fromEntries(new URLSearchParams(window.location.search))
    : {};

  const params = pickBy(
    {
      projectId,
      slug: getOrgSlug(),
      ...existingParams,
      ...query,
    },
    (value) => {
      if (value === false || value === 0) return true;
      if (typeof value === 'number') return true;
      return !isEmpty(value);
    }
  );
  replaceRoute('projects/change-impacts', params);
};

export const navigateToChangeImpactDataImport = (query) => {
  const existingParams = window.location.pathname.includes(
    '/projects/change-impacts/data-import'
  )
    ? Object.fromEntries(new URLSearchParams(window.location.search))
    : {};

  const params = pickBy(
    {
      ...existingParams,
      ...query,
    },
    (value) => {
      if (value === false || value === 0) return true;
      return !isEmpty(value);
    }
  );
  replaceRoute('projects/change-impacts/data-import', params);
};
